class PivotDiagram extends HTMLElement {
  constructor() {
    super();
    this.ticking = false;
    this.boundOnScroll = () => this.onScroll();
  }

  connectedCallback() {
    this.image = this.querySelector('.diagram-image');
    if (!this.image) return;

    this.enableFade = this.dataset.enableFade === 'true';
    this.FADE_PX = this.enableFade ? 80 : 0;

    window.addEventListener('scroll', this.boundOnScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.boundOnScroll);
  }

  onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  update() {
    if (!this.image) return;

    const rect = this.image.getBoundingClientRect();
    const imgH = rect.height;
    const viewportH = window.innerHeight;

    // Progress: 0 when top enters viewport from below, 1 when fully revealed
    const totalTravel = (imgH + viewportH) * 0.85;
    const traveled = viewportH - rect.top;
    const progress = Math.max(0, Math.min(1, traveled / totalTravel));

    // How much to clip from the bottom (100% = fully hidden, 0% = fully visible)
    const clipBottom = (1 - progress) * 100;

    if (this.enableFade && progress > 0 && progress < 1) {
      // Calculate fade edge position in pixels from top of image
      const visiblePx = progress * imgH;
      const fadeStartPx = Math.max(0, visiblePx - this.FADE_PX);
      const fadeStartPct = (fadeStartPx / imgH) * 100;
      const fadeEndPct = (visiblePx / imgH) * 100;

      this.image.style.clipPath = 'none';
      this.image.style.maskImage = `linear-gradient(to bottom, black ${fadeStartPct}%, transparent ${fadeEndPct}%)`;
      this.image.style.webkitMaskImage = `linear-gradient(to bottom, black ${fadeStartPct}%, transparent ${fadeEndPct}%)`;
    } else {
      // No fade: use simple clip-path
      this.image.style.maskImage = 'none';
      this.image.style.webkitMaskImage = 'none';
      this.image.style.clipPath = `inset(0 0 ${clipBottom}% 0)`;
    }
  }
}

customElements.define('pivot-diagram', PivotDiagram);



